<template>
  <pane
    id="add-fields"
    :title="$t('toolbar.addFields.title')"
    :label="$t('toolbar.addFields.label')"
    :icon="AddIcon"
  >
    <add-fields v-bind="{ ...$props, ...$attrs }" />
  </pane>
</template>

<script lang="ts" setup>
import Pane from '@components/utils/toolbar/Pane.vue';
import AddFields, { type Field } from '@components/utils/filter/AddFields.vue';
import AddIcon from '@images/panes/add.svg?component';

export interface Props {
  modelValue: Record<string, boolean>;
  fields: Field[];
}

defineProps<Props>();
</script>

<style lang="scss" scoped></style>
